// src/stores/user.ts
import { defineStore } from 'pinia'
import type { UserInfo } from '@/types/user' 

export const useUserStore = defineStore('user', {
  // 1. 状态：从 localStorage 初始化 token，实现“刷新不掉线”
  state: () => ({
    token: localStorage.getItem('token') || '',
    userInfo: (() => {
      const raw = localStorage.getItem('userInfo')
      return raw ? JSON.parse(raw) : null
    })() as UserInfo | null
  }),

  // 2. 动作（Actions）
  actions: {
    /**
     * 登录成功处理
     */
    login(newToken: string, info?: UserInfo) {
      this.token = newToken
      
      // 如果登录接口直接返回了用户信息，则存入；否则保留之前的或为空
      if (info) {
        this.userInfo = info
        this.setUserInfo(info) // 同步写入本地存储
      }
      
      // 【关键】同步写入本地存储
      localStorage.setItem('token', newToken)
    },

    /**
     * 退出登录
     */
    logout() {
      this.token = ''
      this.userInfo = null
      
      // 【关键】清除本地存储
      localStorage.removeItem('token')
      
      // 可选：清除其他相关缓存，如 user_info
      localStorage.removeItem('userInfo') 
    },

    /**
     * 设置用户信息（用于登录后异步获取用户详情）
     */
    setUserInfo(info: UserInfo) {
      this.userInfo = info
      // 可选：将用户信息也持久化，减少请求
      localStorage.setItem('userInfo', JSON.stringify(info))
    }
  }
})